// extracted by mini-css-extract-plugin
module.exports = {"recruitSection":"recruit-module--recruitSection--1qLPO","title":"recruit-module--title--1n6DC","textBox":"recruit-module--textBox--17TXj"};